<template>
  <div id="js-lang-bar" class="choose-lang-div">
    <div
        v-for="lang in languages"
        :key="lang.code"
        :class="{ 'selected': lang.code === selectedLanguage }"
        :data-value="lang.code"
        class="lang-div"
        @click="selectLanguage(lang.code)"
    >
      {{ lang.name }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import {getCurrentInstance, onMounted, ref} from 'vue'

const { proxy } = getCurrentInstance()!;
const $cookies = proxy!.$cookies;


defineOptions({
  name: 'LanguageSelection'
});

const props = withDefaults(defineProps<{ initialLang?: string }>(), {
  initialLang: 'et'
})
const selectedLanguage = ref('et')
const languages = [
  {code: 'et', name: 'Eesti'},
  {code: 'en', name: 'English'},
  {code: 'ru', name: 'Русский'}
]

onMounted(() => {
  const userLanguage = $cookies.get('language')
  selectedLanguage.value = userLanguage || props.initialLang
})

function selectLanguage(langCode: string) {
  $cookies.set('language', langCode)
  window.location.reload()
}
</script>

<style scoped>
.choose-lang-div {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
  justify-content: center;
}

.lang-div {
  font-size: 13px;
  color: #727272;
  padding-bottom: 10px;
  cursor: pointer;
  margin-right: 20px;

  &:hover {
    color: #000;
  }

  &.selected {
    border-bottom: solid 4px #2EB336;
    color: #2EB336;
    font-weight: 500;
  }
}


</style>
